<template>
  <v-row v-bind="oattrs" no-gutters>
    <v-col :md="nCols" :lg="nCols" :xl="nCols" sm="12">
      <v-menu v-model="bInicio" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto" nudge-left="44" >
        <template v-slot:activator="{ on, attrs }">
          <span class="titleslight--text"> {{ oEquivalencia.cmpFechaInicio }} <span class="error--text">*</span> </span>
          <v-text-field
            v-model="formattedFechaRangoInicio"
            outlined
            append-icon="mdi-calendar"
            placeholder="DD/MM/AAAA"
            dense
            readonly
            v-bind="attrs"
            v-on="on"
            class="pr-1"
            id="InputFechaRangoInicio"
          >
            <template v-slot:append>
              <v-icon id="IconoCalendarInicio" @click="bInicio = !bInicio">mdi-calendar</v-icon>
            </template>
          </v-text-field>
        </template>
        <v-date-picker v-model="sFechaRangoInicio" @input="bInicio = false" no-title scrollable :max="sFechaRangoFin" locale="es-CO"/>
      </v-menu>
    </v-col>

    <v-col :md="nCols" :lg="nCols" :xl="nCols" sm="12" v-if="bHora">
      <span class="titleslight--text"> {{ oEquivalencia.ttlHoraInicio }} <span class="error--text">*</span> </span>
      <v-select
        v-model="sHoraRangoInicio"
        :items="aHoras"
        :placeholder="oEquivalencia.lblElegirHora"
        height="30px"
        outlined
        dense
        append-icon="mdi-clock"
      />
    </v-col>


    <v-col :md="nCols" :lg="nCols" :xl="nCols" sm="12" :class="[$vuetify.breakpoint.sm ? '' : 'pl-2']">
      <v-menu v-model="bFin" :close-on-content-click="false" :nudge-right="oattrs?.nudgeRigthEnd ? oattrs?.nudgeRigthEnd : 40" transition="scale-transition" offset-y min-width="auto" nudge-top="0" nudge-left="40" :disabled="!bHabilitarCampoFecha">
        <template v-slot:activator="{ on, attrs }">
          <span class="titleslight--text"> {{ oEquivalencia.cmpFechaFinalizacion }} <span class="error--text">*</span> </span>
          <v-text-field
            :disabled="!bHabilitarCampoFecha"
            v-model="formattedFechaRangoFin"
            outlined
            append-icon="mdi-calendar"
            placeholder="DD/MM/AAAA"
            dense
            readonly
            v-bind="attrs"
            v-on="on"
            :class="[!$vuetify.breakpoint.sm ? 'pl-2' : '','mr-1', !sFechaRangoInicio ? 'customDisabled' : '']"
            id="InputFechaRangoFin"
          >
            <template v-slot:append>
              <v-icon @click="bFin = !bFin">mdi-calendar</v-icon>
            </template>
          </v-text-field>
        </template>
        <v-date-picker
          v-model="sFechaRangoFin"
          @input="bFin = false"
          :min="sFechaRangoInicio"
          :max="sMaximaFecha"
          locale="es-CO"
          no-title 
          scrollable
        />
      </v-menu>
    </v-col>
    
    <v-col :md="nCols" :lg="nCols" :xl="nCols" sm="12" v-if="bHora">
      <span class="titleslight--text"> {{ oEquivalencia.ttlHoraFinal }} <span class="error--text">*</span> </span>
      <v-select
        v-model="sHoraRangoFin"
        :items="horasFiltradasFinal"
        :disabled="!bHabilitarCampoFecha"
        :placeholder="oEquivalencia.lblElegirHora"
        height="30px"
        outlined
        dense
        append-icon="mdi-clock"
      />
    </v-col>

  </v-row>
</template>
<script>
export default {
  props: {
    oattrs: {
      type: Object,
      default: () => {},
    },
    bHora: {
      type: Boolean,
      default: false,
    },
    nCols: {
      type: Number,
      default: 6,
    },
    propFechaRango: {
      type: Array,
      default: () => ([]),
    },
    nMaximoDias: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      oEquivalencia: this.$store.state.jsIdioma.oEquivalencias,
      bInicio: false,
      bFin: false,
      sFechaRangoInicio: null, // new Date().toISOString().substr(0, 10),
      sFechaRangoFin: null, // new Date().toISOString().substr(0, 10),
      sHoraRangoInicio: null,
      sHoraRangoFin: null,
      bInicioHora: false,
      sMaximaFecha: null,
      aHoras:["00:00", "00:30", "01:00", "01:30", "02:00", "02:30", "03:00", "03:30", "04:00", "04:30", "05:00", "05:30", "06:00", "06:30", "07:00", "07:30", "08:00", "08:30", "09:00", "09:30", "10:00", "10:30", "11:00", "11:30", "12:00", "12:30", "13:00", "13:30", "14:00", "14:30", "15:00", "15:30", "16:00", "16:30", "17:00", "17:30", "18:00", "18:30", "19:00", "19:30", "20:00", "20:30", "21:00", "21:30", "22:00", "22:30", "23:00", "23:30"]
    };
  },
  mounted() {
    if (this.propFechaRango.length > 0) {
      let aTempFechaInicio = this.propFechaRango[0].split(" ");
      this.sFechaRangoInicio = aTempFechaInicio[0];
      if (this.bHora&&aTempFechaInicio.length>1) {
        this.sHoraRangoInicio = aTempFechaInicio[1];
      }

      let aTempFechaFin = this.propFechaRango[1].split(" ");
      this.sFechaRangoFin = aTempFechaFin[0];
      if (this.bHora&&aTempFechaFin.length>1) {
        this.sHoraRangoFin = aTempFechaFin[1];
      }
    }
  },
  computed: {
    cmp_RangoExportar() {
      let aResult = [this.sFechaRangoInicio+(this.sHoraRangoInicio!=null?" "+this.sHoraRangoInicio:""), this.sFechaRangoFin+(this.sHoraRangoFin!=null?" "+this.sHoraRangoFin:"")];

      this.$emit("onAFechaRango", aResult);

      return aResult;
    },
    horasFiltradasFinal() {
      if (!this.sHoraRangoInicio || this.sFechaRangoInicio != this.sFechaRangoFin) {
        return this.aHoras;
      }
      const [horaInicio, minutoInicio] = this.sHoraRangoInicio.split(':').map(Number);
      return this.aHoras.filter(hora => {
        const [horaActual, minutoActual] = hora.split(':').map(Number);
        return horaActual > horaInicio || (horaActual === horaInicio && minutoActual >= minutoInicio);
      });
    },
    bHabilitarCampoFecha(){
      if(this.sFechaRangoInicio==null || this.sFechaRangoInicio=="" || (this.bHora && (this.sHoraRangoInicio==null || this.sHoraRangoInicio==""))){
        return false;
      }

      return true;
    },
    formattedFechaRangoInicio() {
      if (!this.sFechaRangoInicio) return '';

      const [year, month, day] = this.sFechaRangoInicio.split('-');
      const date = new Date(year, month - 1, day); // Los meses en JavaScript empiezan en 0
      const formattedDay = String(date.getDate()).padStart(2, '0');
      const formattedMonth = String(date.getMonth() + 1).padStart(2, '0'); // Los meses en JavaScript empiezan en 0
      const formattedYear = date.getFullYear();

      return `${formattedDay}/${formattedMonth}/${formattedYear}`;
    },
    formattedFechaRangoFin(){
      if (!this.sFechaRangoFin) return '';

      const [year, month, day] = this.sFechaRangoFin.split('-');
      const date = new Date(year, month - 1, day); // Los meses en JavaScript empiezan en 0
      const formattedDay = String(date.getDate()).padStart(2, '0');
      const formattedMonth = String(date.getMonth() + 1).padStart(2, '0'); // Los meses en JavaScript empiezan en 0
      const formattedYear = date.getFullYear();

      return `${formattedDay}/${formattedMonth}/${formattedYear}`;
    },
    isMobile() {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm;
    }
  },
  watch: {
    sFechaRangoInicio() {
      //validamos que si la fecha final es menor que la inicial la reseteamos, ya que el usuario pudo haber seleccionado primero la final y luego la incial
      if (this.sFechaRangoInicio > this.sFechaRangoFin) {
        this.sFechaRangoFin = this.sFechaRangoInicio;
      }

      //validamos si la configuracion tiene unos dias maximos
      if(this.nMaximoDias==0){
        this.sMaximaFecha= null;
      }
      else{
        let fechaInicio = new Date(this.sFechaRangoInicio);
        fechaInicio.setDate(fechaInicio.getDate() + this.nMaximoDias); 
        this.sMaximaFecha = fechaInicio.toISOString().substr(0, 10);
        
        //validamos como tiene dias maximos que la fecha final no sobre pase esos dias desde la inicial
        if(this.sFechaRangoFin!=null){
          const startDate = new Date(this.sFechaRangoInicio);
          const endDate = new Date(this.sFechaRangoFin);
          const diffInDays = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));

          if (diffInDays > this.nMaximoDias) {
            const maxEndDate = new Date(this.sFechaRangoInicio);
            maxEndDate.setDate(maxEndDate.getDate() + this.nMaximoDias);
            this.sFechaRangoFin = maxEndDate.toISOString().split('T')[0]; // Formato YYYY-MM-DD
          }
        }
      }

      this.$emit("onFechaInicio", this.sFechaRangoInicio);
    },
    sFechaRangoFin() {
      this.$emit("onFechaFin", this.sFechaRangoFin);
    },
    cmp_RangoExportar() {
      if (this.cmp_RangoExportar.every((item) => item !== null)) {
        this.$emit("onExportarRango", this.cmp_RangoExportar);
      }
    },
  },
};
</script>
<style>
.customDisabled > .v-input__control > .v-input__slot {
  background-color: rgba(0, 0, 0, 0.10) !important;
}
.titleslight--text {
  font-size: 1rem;
  @media (max-width: 1280px) {
    font-size: 0.75rem;
  }
}
</style>